import * as React from 'react'
import { Body2AccentTypography, CaptionTypography, LoadingSpinner } from '@components/atoms';
import { CenteredLayout, PageContentMain } from '@components/molecules';

interface PageContentMapperProps {
	actions?: React.ReactNode;
	children: React.ReactNode;
	isLoading: boolean;
	isError: boolean;
	NoDataPage?: React.ReactNode;
	isEmptyPage?: boolean;
	errorMessage: string | React.ReactNode;
	pageContentClassName?: string;
}

const PageContentMapper = ({
	NoDataPage,
	isEmptyPage,
	children,
	isLoading,
	isError,
	errorMessage,
	pageContentClassName,
}: PageContentMapperProps) => {
	if (isLoading) {
		return (
			<CenteredLayout>
				<LoadingSpinner />
			</CenteredLayout>
		);
	} else if (isError) {
		return (
			<CenteredLayout className="p-5">
				{typeof errorMessage === 'string' ? (
					<>
						<Body2AccentTypography className="text-error xs:hidden lg:block" truncate={false}>
							{errorMessage}
						</Body2AccentTypography>
						<CaptionTypography className="text-error lg:hidden" truncate={false}>
							{errorMessage}
						</CaptionTypography>
					</>
				) : (
					errorMessage
				)}
			</CenteredLayout>
		);
	} else if (isEmptyPage && NoDataPage) {
		return <CenteredLayout>{NoDataPage}</CenteredLayout>;
	}

	return <PageContentMain className={pageContentClassName}>{children}</PageContentMain>;
};

PageContentMapper.displayName = 'PageContentMapper';

export { PageContentMapper };
